import notificationImage from '../../../assets/notification.png';
import { FaArrowLeft } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const MobileNotification = () => {

  const navigate = useNavigate();

  const handleBack = () => {
    navigate(0);
  };
  return (
    <>
      <div className="w-full bg-[#FF9630] text-white py-4 px-6 flex items-center">
        <button onClick={handleBack} className="mr-4 text-white hover:text-gray-200">
          <FaArrowLeft className="text-lg" />
        </button>
        <h1 className="text-xl font-semibold">Notification</h1>
      </div>
      <div className="flex items-center justify-center h-screen w-full bg-gray-50 border">
        <div className="text-center">
          <div className="flex justify-center items-center w-full bg-gray-100 rounded-full">
            <img src={notificationImage} alt="Notification Icon" className="" />
          </div>
          <h2 className="text-xl font-semibold text-gray-600">No Notifications</h2>
          <p className="text-gray-500">Notification Inbox Empty</p>
        </div>
      </div>
    </>
  );
};

export default MobileNotification;
